<form
    [formGroup]="paymentForm"
    (ngSubmit)="onSubmit(paymentForm.value)"
    *ngIf="paymentSent === false"
>
    <fieldset>
        <p>
            Please select the examination type and enter the quantity of vouchers you
      would like to purchase and then select 'Submit'. The total voucher
      purchase must be less than $10,000. If the amount exceeds this, multiple
      purchases will be necessary.
        </p>
        <span style="font-size: smaller; font-weight: bolder">
            Important information to know before purchasing a voucher:
            <br>
        </span>
        <ul style="font-size: smaller">
            <li>
                Vouchers may be purchased for any combination of exams
            </li>
            <li>
                Each prepaid voucher covers the application fee for one exam
            </li>
            <li>
                Vouchers may not be redeemed for cash or used for other NBRC
        services/products
            </li>
            <li>
                Vouchers are valid for one year from the date of purchase
            </li>
            <li>Vouchers are only redeemable online</li>
            <li>
                Distribute voucher codes to exam candidates as needed when they are
        ready to apply for an examination
            </li>
            <li>
                Exam candidates will enter their voucher code online when applying for
        the exam
            </li>
            <li>All eligibility requirements apply</li>
        </ul>
        <legend>Payment Information</legend>
        <div class="nested-fields">
            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="serviceId"
                        class="label"
                    >
                        Vouchers available for purchase
                    </label>
                    <select
                        class="input input--select-menu"
                        style="max-width: 40em"
                        [class.input--invalid]="formErrors.serviceId"
                        id="serviceId"
                        formControlName="serviceId"
                        name="serviceId"
                    >
                        <option value>--Please select a voucher---</option>
                        <option
                            *ngFor="let exam of this.examList"
                            [value]="exam.serviceId"
                        >
                            {{ exam.examTitle }}
                        </option>
                    </select>

                     <!-- TMC warning -->
                    <div *ngIf="selectedExam?.examCode === 'TMC'" class="info-message" style="color: red;">
                        All vouchers purchased for the Therapist Multiple-Choice (TMC) Examination
                        will expire on December 15, 2026 due to implementation of the
                        Respiratory Therapy Examination. Refunds will not be issued for unused vouchers.
                    </div>
                    <!-- CSE warning -->
                    <div *ngIf="showCseMessage" class="info-message" style="color: red;">
                        All vouchers purchased for the Clinical Simulation (CSE) Examination
                        will expire on December 15, 2027 due to implementation of the
                        Respiratory Therapy Examination. Refunds will not be issued for unused vouchers. 
                    </div>
                    
                    <div
                        *ngIf="formErrors.serviceId"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.serviceId }}
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="quantity"
                        class="label"
                    >
                        Qty
                    </label>
                    <input
                        class="input input--small"
                        [class.input--invalid]="formErrors.quantity"
                        formControlName="quantity"
                        id="quantity"
                        name="quantity"
                        max="100"
                        min="0"
                        step="1"
                        type="number"
                    >
                    <div
                        *ngIf="formErrors.quantity"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.quantity }}
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="email"
                        class="label"
                    >
                        Email
                    </label>
                    <input
                        class="input input--large"
                        [class.input--invalid]="formErrors.email"
                        id="email"
                        formControlName="email"
                        maxlength="75"
                    >
                    <div
                        *ngIf="formErrors.email"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.email }}
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="company"
                        class="label"
                    >
                        Company
                        <span class="label__help-text">(optional)</span>
                    </label>
                    <input
                        class="input"
                        [class.input--invalid]="formErrors.company"
                        id="company"
                        formControlName="company"
                        maxlength="50"
                    >
                    <div
                        *ngIf="formErrors.company"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.company }}
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="field form-row__item form-row__item--medium">
                    <div class="field__label-input-wrap">
                        <label
                            for="firstName"
                            class="label"
                        >
                            First Name
                        </label>
                        <div class="field__label-input-wrap">
                            <input
                                class="input"
                                [class.input--invalid]="formErrors.firstName"
                                id="firstName"
                                formControlName="firstName"
                                maxlength="35"
                            >
                            <div
                                *ngIf="formErrors.firstName"
                                class="error-message field__error-message"
                            >
                                {{ formErrors.firstName }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="lastName"
                            class="label"
                        >
                            Last Name
                        </label>
                        <input
                            class="input"
                            [class.input--invalid]="formErrors.lastName"
                            id="lastName"
                            formControlName="lastName"
                            maxlength="35"
                        >
                        <div
                            *ngIf="formErrors.lastName"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.lastName }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="field form-row__item form-row__item--medium">
                    <div class="field__label-input-wrap">
                        <label
                            for="cardNumber"
                            class="label"
                        >
                            Card Number
                        </label>
                        <div
                            class="credit-card-number-input-wrap"
                            [class.credit-card-number-input-wrap--populated]="ccType"
                            [class.credit-card-number-input-wrap--amex]="
                ccType === cardTypes.Amex
              "
                            [class.credit-card-number-input-wrap--discover]="
                ccType === cardTypes.Discover
              "
                            [class.credit-card-number-input-wrap--mastercard]="
                ccType === cardTypes.MasterCard
              "
                            [class.credit-card-number-input-wrap--visa]="
                ccType === cardTypes.Visa
              "
                        >
                            <input
                                class="input input--medium"
                                [class.input--invalid]="formErrors.cardNumber"
                                formControlName="cardNumber"
                                id="cardNumber"
                                mask="0000 0000 0000 0000||0000 000000 00000"
                                [dropSpecialCharacters]="true"
                            >
                            <div
                                *ngIf="formErrors.cardNumber"
                                class="error-message field__error-message"
                            >
                                {{ formErrors.cardNumber }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="expirationDate"
                            class="label"
                        >
                            Exp. Date
                        </label>
                        <input
                            class="input input--small"
                            [class.input--invalid]="formErrors.expirationDate"
                            formControlName="expirationDate"
                            id="expirationDate"
                            [dropSpecialCharacters]="true"
                            placeholder="MM/YY"
                            mask="00/00"
                        >
                        <div
                            *ngIf="formErrors.expirationDate"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.expirationDate }}
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="ccv"
                            class="label"
                        >
                            CCV
                        </label>
                        <input
                            class="input input--small"
                            [class.input--invalid]="formErrors.ccv"
                            formControlName="ccv"
                            id="ccv"
                            mask="000||0000"
                            placeholder="123"                            
                        >
                        <div
                            *ngIf="formErrors.ccv"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.ccv }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="address"
                        class="label"
                    >
                        Address
                    </label>
                    <input
                        class="input input--large"
                        [class.input--invalid]="formErrors.address"
                        id="address"
                        formControlName="address"
                        maxlength="35"
                    >
                    <div
                        *ngIf="formErrors.address"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.address }}
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="city"
                            class="label"
                        >
                            City
                        </label>
                        <input
                            class="input"
                            [class.input--invalid]="formErrors.city"
                            id="city"
                            formControlName="city"
                            maxlength="35"
                        >
                        <div
                            *ngIf="formErrors.city"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.city }}
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="state"
                            class="label"
                        >
                            State
                        </label>
                        <input
                            class="input"
                            [class.input--invalid]="formErrors.state"
                            id="state"
                            formControlName="state"
                            maxlength="2"
                        >
                        <div
                            *ngIf="formErrors.state"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.state }}
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="zip"
                            class="label"
                        >
                            Zip&#x2F;Postal Code
                        </label>
                        <input
                            class="input"
                            [class.input--invalid]="formErrors.zip"
                            formControlName="zip"
                            id="zip"
                            mask="00000"
                            [dropSpecialCharacters]="true"
                        >
                        <div
                            *ngIf="formErrors.zip"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.zip }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="field form-row__item">
                    <re-captcha
                        #captchaElem
                        [siteKey]="siteKey"                        
                        [size]="size"
                        [hl]="lang"
                        [theme]="theme"
                        [type]="type"
                        (resolved)="handleSuccess($event)"
                        (expired)="handleReset()"
                        formControlName="recaptcha"
                    >
                    </re-captcha>
                </div>
            </div>
        </div>
        <p>
            By clicking Submit, I agree to pay
      {{ amount | currency : "USD" : true }} according to the cardholder
      agreement.
        </p>
        <div
            [hidden]="!serverMessage"
            class="error-message field__error-message"
        >
            {{ serverMessage }}
        </div>
        <div class="form-actions form-actions--multi-step">
            <input
                class="button form-actions__item form-actions__item--continue"
                name="submitButton"
                type="submit"
                value="Submit"
            >
            <button
                (click)="onCancel($event)"
                class="button button--secondary form-actions__item form-actions__item--back"
            >
                Cancel
            </button>
        </div>
        <div
            *ngIf="formLevelErrors"
            class="error-message field__error-message"
        >
            <p *ngFor="let error of formLevelErrors">{{ error }}</p>
        </div>
    </fieldset>
</form>
<div *ngIf="paymentSent">
    <p>
        An email with your voucher code(s) will be sent to {{ email }}. If you don't
    receive your voucher code email within 24 hours, please contact us at
        <a href="mailto:nbrc-info@nbrc.org">nbrc-info@nbrc.org</a>
        or
        <a href="tel:9138954900">913.895.4900</a>
        .
    </p>
    <p>
        Thank you for your purchase. The voucher code(s) may be used only for
    payment of the examination fee indicated. The voucher code must be entered
    at the time of online application and cannot be applied after an individual
    has registered for an examination. Voucher codes are valid for one year from
    the date of purchase.
    </p> 

    <p>
        Please contact us at
        <a href="mailto:nbrc-info@nbrc.org">nbrc-info@nbrc.org</a>
        or
        <a href="tel:9138954900">913.895.4900</a>
        if you have any questions.
    </p>
</div>
